import React from 'react';

interface BlogPageProps {
  isDark: boolean;
}

const BlogPage: React.FC<BlogPageProps> = ({ isDark }) => {
  return (
    <div className="min-h-screen pt-24 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-5xl font-extrabold mb-8 bg-gradient-to-r from-red-500 via-purple-500 to-blue-500 bg-clip-text text-transparent pb-2">
          Blog
        </h1>
        <p className={`text-xl mb-8 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
          Coming soon! This is where I'll share thoughts on development, technology, and projects I'm working on.
        </p>
        <div className={`rounded-xl p-8 ${isDark ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-200'}`}>
          <h2 className="text-2xl font-bold mb-4">Stay tuned...</h2>
          <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>
            Blog posts will appear here soon. In the meantime, check out my projects on the home page!
          </p>
        </div>
      </div>
    </div>
  );
};

export default BlogPage;